(function() { //scope for sponsored links. Make sure to execute this before ads load (because it can affect the layout)
	const $sponsLinks = $('.js-sponsor-wrapper');
	if($sponsLinks.length === 0) {return;} //no sponsored links on this page

	const $h2s = $('.content h2');
	$sponsLinks.each(function() {
		const $this = $(this);
		const placement = $this.data('placement');
		if(placement == '1') {
			if($h2s.length > 5) {
				//When it's a long article, step it down a notch to spread it more evenly
				placeBefore($this.children(), $h2s[1]);
			} else {
				//place before first h2
				placeBefore($this.children(), $h2s[0]);
			}
		} else {
			//place at the midpoint. Test this later and see how it works with a potential midcontent-ad etc
			var midpoint = Math.floor($h2s.length / 2);
			if(midpoint < $h2s.length - 1) {
				midpoint += 1; //if there are more than two H2s, place it at midpoint + 1 instead (then it will not conflict with mid-content ad banners)
			}
			if(placement == '3' && $h2s.length > midpoint + 2) {
				midpoint += 2;
			}
			placeBefore($this.children(), $h2s[midpoint]);
		}
	});

	function placeBefore($objects, h2ToPlaceBefore) {
		if(h2ToPlaceBefore.parentNode.className.indexOf('microdata-content-section') > -1) {
			$objects.insertBefore(h2ToPlaceBefore.parentNode);
		} else {
			$objects.insertBefore(h2ToPlaceBefore);
		}
	}
})();


const ads = [
	{
		invCode: 'Altomhelse_top_980x240px',
		targetId: 'Altomhelse_top_980x240px',
		tagId: 17320019,
		sizes: [[980,240], [980,120], [980,360]]
	}, {
		invCode: 'Altomhelse_top_980x240px_2',
		targetId: 'Altomhelse_top_980x240px_2',
		tagId: 24123346,
		sizes: [[980,240], [980,120], [980,360]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_1',
		targetId: 'Altomhelse_desktop_250x360px_1',
		tagId: 17320022,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_2',
		targetId: 'Altomhelse_desktop_250x360px_2',
		tagId: 17320023,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_3',
		targetId: 'Altomhelse_desktop_250x360px_3',
		tagId: 17320026,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_4',
		targetId: 'Altomhelse_desktop_250x360px_4',
		tagId: 17320027,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_5',
		targetId: 'Altomhelse_desktop_250x360px_5',
		tagId: 17320028,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_6',
		targetId: 'Altomhelse_desktop_250x360px_6',
		tagId: 17320030,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_7',
		targetId: 'Altomhelse_desktop_250x360px_7',
		tagId: 17320031,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_8',
		targetId: 'Altomhelse_desktop_250x360px_8',
		tagId: 17320034,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_9',
		targetId: 'Altomhelse_desktop_250x360px_9',
		tagId: 17320036,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_desktop_250x360px_10',
		targetId: 'Altomhelse_desktop_250x360px_10',
		tagId: 17320041,
		sizes: [[250,360], [250,480], [250,600], [250,120]]
	}, {
		invCode: 'Altomhelse_content_510x240px_1',
		targetId: 'Altomhelse_content_510x240px_1',
		tagId: 17320046,
		sizes: [[510,240], [510,150]]
	}, {
		invCode: 'Altomhelse_content_510x240px_2',
		targetId: 'Altomhelse_content_510x240px_2',
		tagId: 17320047,
		sizes: [[510,240], [510,150]]
	}, {
		invCode: 'Altomhelse_mobile_320x320px_1',
		targetId: 'Altomhelse_mobile_320x320px_1',
		tagId: 17320060,
		sizes: [[320,320], [300,250], [320,160], [320,80], [510,240], [510,150], [250,120]]
	}, {
		invCode: 'Altomhelse_mobile_320x320px_2',
		targetId: 'Altomhelse_mobile_320x320px_2',
		tagId: 17320062,
		sizes: [[320,320], [300,250], [320,160], [320,80], [250,120]]
	}, {
		invCode: 'Altomhelse_mobile_320x320px_3',
		targetId: 'Altomhelse_mobile_320x320px_3',
		tagId: 17320070,
		sizes: [[320,320], [300,250], [320,160], [320,80], [250,120]]
	}, {
		invCode: 'Altomhelse_mobile_320x320px_4',
		targetId: 'Altomhelse_mobile_320x320px_4',
		tagId: 24123352,
		sizes: [[320,320], [300,250], [320,160], [320,80], [250,120]]
	}, {
		invCode: 'Altomhelse_mobile_leaderboard_320x50px',
		targetId: 'Altomhelse_mobile_leaderboard_320x50px',
		tagId: 17320084,
		sizes: [[320,50]]
	}
];
//define placement groups
const topAds = ads.filter(ad => ad.targetId.indexOf('Altomhelse_top') === 0);
const sideAds = ads.filter(ad => ad.targetId.indexOf('Altomhelse_desktop_') === 0);
const contentAds = ads.filter(ad => ad.targetId.indexOf('Altomhelse_content_') === 0);
const mobileAds = ads.filter(ad => ad.targetId.indexOf('Altomhelse_mobile_3') === 0);

//define functions
function isInViewport(element) {
	if(element.offsetParent === null) {return false;} //never show ads hidden via CSS
	const offsetPadding = 200;  //load ads about 200px before they enter viewport, in accordance with recommendations from platform partners
	var height = document.documentElement.clientHeight + offsetPadding;
	if(element.parentNode === null) { return false; } //because otherwise IE bugs the fuck out lol
	return (element.getBoundingClientRect().top < height);
}
function shouldStillBeInViewport(element, stackIndex) {
	const offsetPadding = 200;  //load ads about 200px before they enter viewport, in accordance with recommendations from platform partners
	var height = document.documentElement.clientHeight + offsetPadding;
	const avgAdHeight = 406; //a sidebar ad of common size with "annons:" marker and margin is 382 px large with 24px margin
	return ((avgAdHeight * stackIndex) + element.getBoundingClientRect().top < height);
}
function checkForAndLoadVisibleAds(adsToCheck) {
	var toLoad = [];
	for(var i = 0; i < adsToCheck.length; i++) {
		//Check if it's set to be visible in current dimensions
		if(adsToCheck[i].element && adsToCheck[i].element.offsetParent !== null) {
			//If so, call loadTag on it
			toLoad.push(adsToCheck[i].invCode);
			adsToCheck[i].loaded = true;
		}
	}
	if(toLoad.length > 0) { apntag.loadTags(toLoad);}
}
function showAdsInViewport(adsToCheck) {
	for(var i = 0; i < adsToCheck.length; i++) {
		//Check if it's visible and currently within the viewport (or close)
		if(isInViewport(adsToCheck[i].element)) {
			//If so, call showTag on it
			if(apntag && apntag.showTag) { apntag.showTag(adsToCheck[i].targetId);}
			adsToCheck[i].shown = true;
		}
	}
}
function removeEmptyAdWrapper($adWrapper) {
	// console.info("removeEmptyAdWrapper");
	if(!$adWrapper.removeClass) { $adWrapper = $($adWrapper);}

	var sibling = $adWrapper.siblings('.components-articles-excerpt-medium-block-2, .components-videos-excerpt-medium-block-2');
	// console.info(sibling);
	if(sibling.length > 0) {
		// console.info('removing borders');
		var el = sibling.children().first();
		el.removeClass('border-b pb-1 mb-1').addClass('relative');
		if($adWrapper.hasClass('components-globals-advertisements-banner-side')) {
			el.removeClass('md:border-b md:mb-1 md:pb-1');
		} else if($adWrapper.hasClass('components-globals-advertisements-banner-mobile')) {
			el.removeClass('sm:border-b sm:pb-1 sm:mb-1');
		}
	}
	// console.info($adWrapper);
	$adWrapper.html('').hide(); //for debugging
	// $adWrapper.detach();
}

//if there are midcontentads, move them to the correct place in the document
const possibleMidContentPlacements = document.getElementById('midcontentads');
if(possibleMidContentPlacements) {
	//define where to place (right before the "middle" of the subheadings)
	var h2s = document.querySelectorAll('.content h2');
	if(h2s.length === 0) { h2s = document.querySelectorAll('.content p'); } //since apparently there are articles without any <h2>
	const midpoint = Math.floor(h2s.length / 2);
	const refH2 = h2s[midpoint];
	//actually move it
	if(refH2.parentNode.className.indexOf('microdata-content-section') > -1) {
		document.querySelector('.content').insertBefore(possibleMidContentPlacements, refH2.parentNode);
	} else {
		refH2.parentNode.insertBefore(possibleMidContentPlacements, refH2);
	}
	//once moved, let it be shown
	possibleMidContentPlacements.removeAttribute('style');
}



const $adStack = $('.js-ad-stack');
if($adStack.length > 0) { //we have a stack of sidebar ads. Render as many ads as can comfortable fit there
	const $template = $('.js-ad-stack-template');
	$template.detach(); //no need to keep this in the document (detach makes the node still accessible, just detached from the doc)
	const avgAdHeight = 406; //a sidebar ad of common size with "annons:" marker and margin is 382 px large with 24px margin
	const currentAds = $adStack.children('.js-banner-wrapper'); //.children() excludes the template
	const adSpaceHeight = $adStack[0].getBoundingClientRect().bottom - currentAds[0].getBoundingClientRect().top; //adstack bottom - last ad top
	const numAdsToFit = Math.min(Math.floor(adSpaceHeight / avgAdHeight), sideAds.length); //the number of ads to load (but don't load more than we have placements)
	// console.table([
	// 	['currentAds', currentAds],
	// 	['adstack', $adStack[0]],
	// 	['adSpaceHeight', adSpaceHeight],
	// 	['numAdsToFit', numAdsToFit]
	// ]);

	for(var i = currentAds.length; i < numAdsToFit; i++) { //add as many more as we can fit
		const $clone = $template.children().clone();
		$clone.find('.js-banner-side').attr('id', 'Altomhelse_desktop_250x360px_' + (i + 1));
		$adStack.append($clone);
	}

	//recheck these values after everything else has loaded
	window.addEventListener('load', function() {
		// console.info('window load triggered');
		const currentAds = $adStack.children('.js-banner-wrapper'); //.children() excludes the template
		const adSpaceHeight = $adStack[0].getBoundingClientRect().bottom - currentAds[0].getBoundingClientRect().top; //adstack bottom - last ad top
		const numAdsToFit = Math.min(Math.floor(adSpaceHeight / avgAdHeight), sideAds.length); //the number of ads to load (but don't load more than we have placements)

		// const toLoad = [];
		for(var i = currentAds.length; i < numAdsToFit; i++) { //add as many more as we can fit
			const $clone = $template.children().clone().removeClass('js-undefined');
			$clone.find('.js-banner-side').attr('id', 'Altomhelse_desktop_250x360px_' + (i + 1));
			$adStack.append($clone);

			//connect element and possible load
			sideAds[i].element = $clone[0];
			// console.info('connected element: ');
			// console.info(sideAds[i]);
		}

		// console.info('add ID to those that did not receive one (e.g. sidebanners outside the stack, loaded directly on page load)');
		//add ID to those that didn't receive one (e.g. sidebanners outside the stack, loaded directly on page load)
		$('.js-banner-side:not([id])').each(function() {
			var $this = $(this);
			$this.attr('id', 'Altomhelse_desktop_250x360px_' + (i + 1)).closest('.js-banner-wrapper').removeClass('js-undefined');
			if(i === sideAds.length) {
				// console.info('Do not have enough placements defined for sidebar placement ' + i);
				// console.info('thus, remove the element and exit');
				removeEmptyAdWrapper($this.closest('.js-banner-wrapper'))
				return;
			}
			//connect element and possible load
			sideAds[i].element = $this[0];
			// console.info('connected element: ');
			// console.info(sideAds[i]);
			i += 1;
		});

	});

} else {
	var i = 0;
	//add ID to those that didn't receive one (e.g. sidebanners outside the stack, loaded directly on page load)
	$('.js-banner-side:not([id])').each(function() {
		var $this = $(this);
		$this.attr('id', 'Altomhelse_desktop_250x360px_' + (i + 1)).closest('.js-banner-wrapper').removeClass('js-undefined');
		//connect element and possible load
		sideAds[i].element = $this[0];
		// console.info('connected element: ');
		// console.info(sideAds[i]);
		i += 1;
	});
}


//Run initial setup when first visiting the page
var toDefine = [];
var toLoad = [];
var toShowImmediately = [];
for(var i = 0; i < ads.length; i++) {
	var ad = ads[i];
	//Check if it exists on the page
	var potentialElement = document.getElementById(ad.targetId);
	if(potentialElement) {
		//If so, cache the element and call defineTag on it
		ad.element = potentialElement;
		$(potentialElement).closest('.js-undefined').removeClass('js-undefined'); //to be easily able to select uninitialized ads later loaded via ajax
		toDefine.push(ad);
		//Check if it's set to be visible in current dimensions
		if(ad.element.offsetParent !== null) {
			//If so, call loadTag on it
			toLoad.push(ad);
			//Check if it's currently within the viewport
			if(isInViewport(ad.element)) {
				//If so, call showTag on it
				if(ad.targetId.indexOf('Altomhelse_desktop_250x360px') === 0) {
					//check if it really *should* be in the viewport once the ads have loaded
					if(shouldStillBeInViewport(ad.element, parseInt(ad.targetId.split('_')[3]))) {
						toShowImmediately.push(ad);
					}
				} else {
					toShowImmediately.push(ad);
				}
			}
		}
	} else if(ad.targetId.indexOf('Altomhelse_desktop_250x360px') === 0) {
		toDefine.push(ad); //define all of these, but only load them later when we find them
		toLoad.push(ad);
	}
}

// console.info('toDefine');
// console.info(toDefine);
// console.info('toLoad');
// console.info(toLoad);
// console.info('toShowImmediately');
// console.info(toShowImmediately);

//queue the initial actions to take as soon as the script is finished loading
apntag.anq.push(function() {
	for(var i = 0; i < toDefine.length; i++) {
		apntag.defineTag(toDefine[i]);
		toDefine[i].defined = true;
	}
});
apntag.anq.push(function() {
	apntag.loadTags(toLoad.map(ad => ad.invCode));
	for(var i = 0; i < toLoad.length; i++) {
		toLoad[i].loaded = true;
	}
	apntag.onEvent('adNoBid', function(adObj) { //when this happens, hide the whole parent div (looks bad with "annons" and then no ad)
		// console.info('adNoBid triggered, removing element: ');
		// console.info(adObj);
		removeEmptyAdWrapper($(document.getElementById(adObj.targetId)).closest('.js-banner-wrapper'));
	});
	apntag.onEvent('adAvailable', 'Altomhelse_mobile_leaderboard_320x50px', function(adObj) {
		setTimeout(() => {
			//show the leaderboard
			$('.leaderboard-banner').addClass('active');
			$('.js-sticky-welcome, .js-sticky-button, .js-sticky-menu').removeClass('mb-1.5').addClass('mb-5');
		}, 2000);
	});
});
apntag.anq.push(function() {
	for(var i = 0; i < toShowImmediately.length; i++) {
		apntag.showTag(toShowImmediately[i].targetId);
		toShowImmediately[i].shown = true;
	}
});

//Assign events
function onResize() {
	var toCheck = ads.filter(ad => (ad.defined && !ad.loaded));
	checkForAndLoadVisibleAds(toCheck);
	showAdsInViewport(toCheck.filter(ad => ad.loaded && !ad.shown));
}
function onScroll() {
	var toCheck = ads.filter(ad => (ad.defined && ad.loaded && ad.element && !ad.shown));
	showAdsInViewport(toCheck);
}
window.addEventListener('load', function() {
	//On('viewport dimension change'):
	//		Check if it's set to be visible in current dimensions
	//		If so, call loadTag on it
	//		Check if it's currently within the viewport
	//		If so, call showTag on it
	window.addEventListener('resize', onResize, {passive:true});
	//On('scroll'):
	//		Check if it's visible and currently within the viewport
	//		If so, call showTag on it
	window.addEventListener('scroll', onScroll, {passive:true});
});

jQuery(document).on('ad_placement_load', function(e) {
	// console.info('ad_placement_load triggered');
	//check which new placements were added and load them.
	const $newAds = $('.js-banner-wrapper.js-undefined .js-banner');
	//Note: they will come without set IDs, since it has no way of knowing the indexing of the placements. But this script should
	const toLoad = [];

	$newAds.each(function() {
		const $this = $(this);
		var definedCount, nextFreeIndex, idTemplate;
		// console.info('new ad placement has been loaded via ajax');
		// console.info(this);
		if($this.hasClass('js-banner-mobile')) {
			definedCount = mobileAds.filter(ad => ad.defined).length;
			if(definedCount < mobileAds.length) {
				nextFreeIndex = definedCount + 1;
				idTemplate = 'Altomhelse_mobile_320x320px_';
			}
		} else if($this.hasClass('js-banner-side')) {
			definedCount = sideAds.filter(ad => ad.element).length;
			if(definedCount < sideAds.length) {
				nextFreeIndex = definedCount + 1;
				idTemplate = 'Altomhelse_desktop_250x360px_';
			}
		} else if($this.hasClass('js-banner-fullwidth')) { //There's currently only one of these, so this is more about future-proofing
			definedCount = topAds.filter(ad => ad.defined).length;
			if(definedCount < topAds.length) {
				nextFreeIndex = definedCount + 1;
				idTemplate = 'Altomhelse_top_980x240px'; //As mentioned, this never actually happens anyway
			}
		} else if($this.hasClass('js-banner-content')) {
			definedCount = contentAds.filter(ad => ad.defined).length;
			if(definedCount < contentAds.length) {
				nextFreeIndex = definedCount + 1;
				idTemplate = 'Altomhelse_content_510x240px_';
			}
		}

		if(nextFreeIndex) {
			//Give it an id
			const id = idTemplate + nextFreeIndex;
			$this.attr('id', id);
			//Connect the element to it's corresponding object in ads
			const newAd = ads.filter(ad => ad.targetId === id)[0];
			newAd.element = this;
			//make sure to start the define/load/show cycle as appropriate
			if(!newAd.defined) {
				if(apntag && apntag.defineTag) { apntag.defineTag(newAd);}
				newAd.defined = true;
			}
			if(!ad.loaded && newAd.element.offsetParent !== null) {
				toLoad.push(newAd.targetId);
				newAd.loaded = true;
			}
			$this.closest('.js-banner-wrapper').removeClass('js-undefined');
		} else {
			// console.info("we're unable to define more placements of this type, so just remove the whole thing");
			removeEmptyAdWrapper($this.closest('.js-banner-wrapper'));
		}
	});
	//TODO: potentially add more sidebar ads in $adStack, if we have increased available space and more placements left
	//(although this can wait since apparently we get a full stack when a full searchresult-page is loaded. Waddayaknow)

	if(toLoad.length > 0) {
		// console.info('loading new ads loaded via ajax');
		// console.info(toLoad);
		if(apntag &&apntag.loadTags) { apntag.loadTags(toLoad);}
	}
	//Also, check if the ads sidebar has increased in height, 'cause if so, add there as well
});
